// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2OFpp","label":"SetPasswdForm_label__2FxDV"};